/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import Columns2 from 'components/Columns2.jsx';
import Group from 'entities/Group';
import GroupName from 'groups/components/GroupName.jsx';
import JoinGroupFormPanel from './JoinGroupFormPanel.jsx';
import JoinGroupAvatarPanel from './JoinGroupAvatarPanel.jsx';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/JoinGroupPage.scss';

type Props = {
  groupJson: ?Object,
  loading: boolean,
};

class JoinGroupPage extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  render() {
    const { groupJson } = this.props;

    // reconstructing on render isn't ideal, but this shouldn't rerender and
    // we need to think through a good solution for serializing models
    // $FlowFixMe it's actually fine for groupJson to be undefined at this point
    const group = Group.fromJSON(groupJson);

    // XXX - This is to fix https://my.trackjs.com/details/9a7be15d01bd4ae98c41d04c4148a8aa.
    // Somehow we're ending up with an empty groupJson here sometimes
    if (!group.id) {
      console.warn('Trying to render an empty group');
      return null;
    }
    const org = group.getOrganization();

    return (
      <CenteredContainer size="large">
        <Box>
          <BoxBody>
            <TitleHeader
              title={
                <span>
                  Join {group.getPossessiveSignature()}
                  <Text element="div" weight="semibold">
                    <GroupName group={group} />
                  </Text>
                </span>
              }
              subtext={org && org.getName()}
              className="JoinGroupPage-title"
            />
            <Columns2 flex reset="tablet" resetFlush>
              <div>
                <JoinGroupAvatarPanel group={group} className="JoinGroupPage-header" />
              </div>
              <JoinGroupFormPanel group={group} />
            </Columns2>
          </BoxBody>
        </Box>
      </CenteredContainer>
    );
  }
}

// TEMP until we can get this by GraphQL
function withGroup(WrappedComponent) {
  return class ConnectJoinGroupPage extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
    state = {
      groupJson: undefined,
      loading: true,
    };

    static contextTypes = {
      router: PropTypes.object.isRequired,
    };

    componentDidMount() {
      const { router } = this.context;
      const { groupCode } = router.params;

      const cleanGroupCode = Group.parseAcceptableGroupCode(groupCode);

      if (cleanGroupCode) {
        Group.fetchByCode(cleanGroupCode).then(
          group => {
            if (group.canJoin()) {
              this.setState({ groupJson: group.toJSON(), loading: false });
            } else {
              router.replace('/error');
              throw new Error('Cannot join group');
            }
          },
          err => {
            console.warn('error loading group', err);
            router.replace(`/join?notFound=${groupCode}`);
          }
        );
      } else {
        router.replace(`/join?notFound=${groupCode}`);
        throw new Error('invalid group code');
      }
    }

    render() {
      if (this.state.loading) {
        return <b>Loading…</b>;
      }
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };
}
export default withGroup(JoinGroupPage);
